import { Fragment, useState } from 'react';
import Decimal from 'decimal.js';
import { Badge, Button, Modal, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  useListRegisterSessionsQuery,
  useLazyGetCashSessionReportPdfQuery,
} from '../../../redux/api/marktApi';
import FormatDateTime from '../../../components/dateTime/FormatDateTime';
import PdfButton from '../../../components/pdf/PdfButton';

const euro = (v) =>
  v === null || v === undefined ? '–' : `${new Decimal(v).toFixed(2)} €`;

const SessionHistoryModal = ({ cashRegister }) => {
  const [show, setShow] = useState(false);
  const { data: sessions, isLoading } = useListRegisterSessionsQuery(
    cashRegister.id,
    { skip: !show }
  );
  const [triggerSessionPdf] = useLazyGetCashSessionReportPdfQuery();

  return (
    <Fragment>
      <Button
        variant='outline-secondary'
        size='sm'
        onClick={() => setShow(true)}
      >
        <i className='fas fa-clock-rotate-left me-1' />
        Sitzungsverlauf
      </Button>
      <Modal show={show} onHide={() => setShow(false)} size='xl'>
        <Modal.Header closeButton>
          <Modal.Title>Sitzungsverlauf – {cashRegister.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isLoading ? (
            <p>Sitzungen werden geladen...</p>
          ) : (
            <Table striped hover size='sm' responsive>
              <thead>
                <tr>
                  <th>Geöffnet</th>
                  <th>Status</th>
                  <th>Geschlossen</th>
                  <th className='text-end'>Endbestand</th>
                  <th>Bericht</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {(sessions || []).map((s) => (
                  <tr key={s.id}>
                    <td>
                      <FormatDateTime dateTime={s.opened_at} />
                    </td>
                    <td>
                      {s.status === 'RUNNING' ? (
                        <Badge bg='success'>läuft</Badge>
                      ) : (
                        <Badge bg='secondary'>geschlossen</Badge>
                      )}
                    </td>
                    <td>
                      {s.closed_at ? (
                        <FormatDateTime dateTime={s.closed_at} />
                      ) : (
                        '–'
                      )}
                    </td>
                    <td className='text-end'>{euro(s.end_balance)}</td>
                    <td>
                      <PdfButton
                        onFetch={() => triggerSessionPdf(s.id).unwrap()}
                        filename={`kassenschluss-${s.id.slice(0, 8)}.pdf`}
                        label='PDF'
                      />
                    </td>
                    <td>
                      <Link
                        to={`/markt/cash-register/session/${s.id}`}
                        className='btn btn-outline-secondary btn-sm'
                        onClick={() => setShow(false)}
                      >
                        öffnen
                      </Link>
                    </td>
                  </tr>
                ))}
                {(!sessions || sessions.length === 0) && (
                  <tr>
                    <td colSpan={6} className='text-center text-muted'>
                      Keine Sitzungen.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShow(false)}>
            schließen
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default SessionHistoryModal;
